'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypeName = exports.PropertyName = exports.NumberLiteral = exports.BooleanLiteral = exports.StringLiteral = exports.Keyword = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  color: ', ';\n'], ['\n  color: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-weight: 500;\n'], ['\n  color: ', ';\n  font-weight: 500;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('styled-material/dist/src/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Keyword = exports.Keyword = _styledComponents2.default.span(_templateObject, _colors.materialColors['purple-700']);
var StringLiteral = exports.StringLiteral = _styledComponents2.default.span(_templateObject, _colors.materialColors['green-700']);
var BooleanLiteral = exports.BooleanLiteral = _styledComponents2.default.span(_templateObject, _colors.materialColors['purple-700']);
var NumberLiteral = exports.NumberLiteral = _styledComponents2.default.span(_templateObject, _colors.materialColors['blue-700']);
var PropertyName = exports.PropertyName = _styledComponents2.default.span(_templateObject2, _colors.materialColors['teal-800']);
var TypeName = exports.TypeName = _styledComponents2.default.span(_templateObject, _colors.materialColors['indigo-600']);
//# sourceMappingURL=syntax.js.map



// WEBPACK FOOTER //
// ../documittu/packages/template/dist/components/ui/syntax.js